import 'moment'
import fdb from './firebase_config.js';
import helpers from './helpers.js';

var mixins = {}

//------------------------------------------------------------------------------

mixins.db = {
  computed: {
    
    my_user(){ return this.$store.getters['users/my_user'] },    
    my_user_key(){ return this.my_user.key || this.my_user['.key'] },    
    is_admin(){ return ( this.$store.getters['users/my_user'] && this.$store.getters['users/my_user'].admin ) },
    show_beta_content(){ return this.$store.state.show_beta_content },

    economy_access(){ return this.is_admin },
    
  },
}

//------------------------------------------------------------------------------

  mixins.generic = {

      computed: {

        show_beta_content(){ return this.$store.state.show_beta_content },
        show_debug_data_boxes(){ return this.$store.state.show_debug_data_boxes },
        
        base_url(){ return this.$store.getters.base_url },
        api_url(){ return this.$store.getters.api_url },        
        
        my_user(){ return this.$store.getters['users/my_user'] },        
        my_user_key(){ return this.$store.getters['users/my_user_key'] },        

      },

      methods: {

        is_user(initials){ return (this.my_user.email == initials+'@milk-studio.dk') },

        triggerIconSignal(symbol){ eventBus.$emit('triggerIconSignal', symbol) },

        openURLNewWindow(url){ window.open(url, '_blank') },

        alert(input){ eventBus.$emit('msg',input) },
        msg(input){ eventBus.$emit('msg',input) },
        alert(input){ eventBus.$emit('alert',input) },
    	  toast(input){ eventBus.$emit('toast',input) },
        openTimelogger(input){ eventBus.$emit('openTimelogger',input) },


        set_small_spinner(visible) { this.$store.commit('set_small_spinner',visible) },
        set_big_spinner(visible) { this.$store.commit('set_big_spinner',visible) },
        

        goto(to){
    			this.$router.push(to)
        },

        // generic use ones (C in CRUD) ----------
        
        getAll(type,key){ return this.$store.getters.getAll(type,key) },
        getOne(type,key){ return this.$store.getters.getOne(type,key) },
        
        //----------------------------------------

        getComments( keytype, key ) {          
          return this.$store.getters['comments/byKey']( keytype, key )
        },

        getCommentsCount( keytype, key ) {
          var c = this.getComments( keytype, key )
          if( !c ) return 0
          return c.length
        },


        closeTimeloggerBasic(){
          this.$store.commit('set__timeloggerBasic_active',false)
        },

        openTimeloggerBasic(input){
          if( input ) this.$store.commit('set__timeloggerBasic_timelog',input)
          this.$store.commit('set__timeloggerBasic_active',true)
        },

        fdb_push( table, entry ){          
          return fdb.ref(table).push(entry)
        },

        item_has_tag( item, tag ){
          if( !item ) return false
          if( !item.tags ) return false
          if( !item.tags.toLowerCase ) return false
          if( item.tags.toLowerCase().indexOf( tag.toLowerCase() ) === -1 ) return false
          return true
        },

        toggleTagAndSave( itemtype, item, tag ){
          if( !item ) return

          var item_key = item.key || item['.key']

          if( !item_key ) return

          var has_tag = this.item_has_tag(item,tag)
          
          if( !has_tag  ) item.tags += ' '+tag

          if( has_tag ) {
            var tags = item.tags || ''
            tags = tags.split(' ')
            tags = tags.filter( (entry) => { return entry && entry.toLowerCase() !== tag.toLowerCase() } )
            item.tags = tags.join(' ')
          }

          fdb.ref(itemtype).child(item_key).update({ tags:item.tags })
          this.triggerIconSignal()
        },
        

      },

      log(input){
        if( this.$store.state.env !== 'local' ) return
        helpers.log(input)
      },

  }

mixins.something = {
  // data, computed, methods, created, otherhooks
}

//------------------------------------------------------------------------------

  export default mixins



// WEBPACK FOOTER //
// ./src/mixins.js